import PlayStory from './PlayStory'
import { PLAY_COPY } from './copy'
import PlCv from './scenes/PlCv'
import PlGames from './scenes/PlGames'
import PlHero from './scenes/PlHero'
import PlProof from './scenes/PlProof'
import PlStart from './scenes/PlStart'
import PlSteps from './scenes/PlSteps'
import PlTalents from './scenes/PlTalents'
import PlVoices from './scenes/PlVoices'

/**
 * Version „Aivy Play“: Produkt-Demo als Verkaufsseite im Aivy-Look. Das Signet
 * setzt sich zusammen, eine Form morpht durch die drei Schritte, Spiele in
 * Form-Masken, Belege als Tetris-Kacheln und am Ende ein Feld zum Anstupsen.
 */
const SECTIONS = [
  { id: 'hero', height: 340, Scene: PlHero },
  { id: 'lebenslauf', height: 360, tone: 'mark', Scene: PlCv },
  { id: 'schritte', height: 520, Scene: PlSteps },
  { id: 'spiele', height: 480, tone: 'white', Scene: PlGames },
  { id: 'talentwerte', height: 380, Scene: PlTalents },
  { id: 'belege', height: 420, Scene: PlProof },
  { id: 'stimmen', height: 340, tone: 'blue', Scene: PlVoices },
  { id: 'start', flow: true, tone: 'white', Scene: PlStart }
]

export default function AivyPlay() {
  return <PlayStory sections={SECTIONS} copy={PLAY_COPY} />
}
